import { Grid } from "@material-ui/core";
import React from "react";
import StockItemDetailsNode from "./StockItemDetailsNode";

export interface StockItemDetailsTypeProps {
  nodeData: Array<any>;
  locationName: any;
  updateTime: any;
  createdTime: any;
  handleOpenEditStockItemsModal: any;
  handleOpenEditMapProductsItemsModal: any;
}

/**
 * StockItemDetailsType Component
 *
 * This component serves as a wrapper for the StockItemDetailsNode component.
 * It receives props related to stock item details and passes them down to the StockItemDetailsNode component.
 */
const StockItemDetailsType: React.FunctionComponent<
  StockItemDetailsTypeProps
> = ({
  nodeData,
  locationName,
  updateTime,
  createdTime,
  handleOpenEditStockItemsModal,
  handleOpenEditMapProductsItemsModal,
}) => {
  return (
    <Grid container style={{ marginTop: "8px" }}>
      <Grid item xs={12}>
        <StockItemDetailsNode
          nodeData={nodeData}
          locationName={locationName}
          updateTime={updateTime}
          createdTime={createdTime}
          handleOpenEditStockItemsModal={handleOpenEditStockItemsModal}
          handleOpenEditMapProductsItemsModal={
            handleOpenEditMapProductsItemsModal
          }
        />
      </Grid>
    </Grid>
  );
};

export default StockItemDetailsType;
